exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-flex[data-v-843663d4]{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.align-center[data-v-843663d4]{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}.text-truncate[data-v-843663d4]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.flag-icon[data-v-843663d4]{width:22px!important;min-width:22px!important;max-width:22px!important;height:14px!important;-webkit-box-flex:0;-ms-flex:0 0 22px;flex:0 0 22px;display:inline-block;background-color:#eee;background-size:cover;background-position:50%;border-radius:2px}", ""]);

// exports
